import { icon } from "./icons";
import { fileNameOf } from "./dom";
import { store } from "./store";

export function renderTabs() {
  const container = document.getElementById("editor-tabs")!;
  const { openFiles, activePath } = store.getState();

  container.innerHTML = "";

  if (openFiles.length === 0) {
    container.style.display = "none";
    return;
  }
  container.style.display = "flex";

  for (const file of openFiles) {
    const name = fileNameOf(file.path);
    const isActive = file.path === activePath;

    const tab = document.createElement("button");
    tab.type = "button";
    tab.className = `group flex shrink-0 items-center gap-2 border-r border-border px-3 py-2 text-sm ${
      isActive ? "bg-background text-foreground" : "text-muted-foreground"
    }`;
    tab.addEventListener("click", () => store.getState().setActivePath(file.path));

    const nameSpan = document.createElement("span");
    nameSpan.className = "max-w-32 truncate";
    nameSpan.textContent = name;
    tab.appendChild(nameSpan);

    if (file.dirty) {
      const dot = document.createElement("span");
      dot.className = "size-1.5 shrink-0 rounded-full bg-foreground";
      tab.appendChild(dot);
    }

    const closeBtn = document.createElement("span");
    closeBtn.setAttribute("role", "button");
    closeBtn.setAttribute("aria-label", `Close ${name}`);
    closeBtn.className = "rounded p-0.5 text-muted-foreground hover:bg-white/10 hover:text-foreground";
    closeBtn.innerHTML = icon("x", "size-3.5");
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      store.getState().closeFile(file.path);
    });
    tab.appendChild(closeBtn);

    container.appendChild(tab);
  }
}
